module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/add-to-unscopables.js
// module id = 941
// module chunks = 25